var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
export function useCenterLogoService({ onCenterLogoChange, onFileUpload }) {
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (active) => {
        setActiveTab(active);
    };
    const handleUrlChange = (event) => {
        onCenterLogoChange(event.target.value);
    };
    const handleFileUpload = (file) => __awaiter(this, void 0, void 0, function* () {
        if (!file) {
            return;
        }
        const uploadedFileUrl = yield onFileUpload(file);
        if (uploadedFileUrl)
            onCenterLogoChange(uploadedFileUrl);
    });
    const handleFileClear = () => {
        onCenterLogoChange(undefined);
    };
    return {
        activeTab,
        handleTabChange,
        handleUrlChange,
        handleFileUpload,
        handleFileClear,
    };
}
//# sourceMappingURL=useCenterLogoService.js.map